import React from 'react';
import './header.scss';

const Header = () => {
	return (
		<header className='header-container'>
			<span className='header-title'>DS-Algo</span>
		</header>
	);
};

export default Header;
